import { DatePicker } from 'antd';
import React, { Component } from 'react';
import moment from 'moment';

const { MonthPicker } = DatePicker;

export default class App extends Component {
    render() {
        const { date, onChange } = this.props;
        return (
            <MonthPicker
                placeholder="请选择年月"
                monthCellContentRender={(date, local) => {
                    return moment(date).format('M月')
                }}
                defaultValue={moment(date, "YYYY-MM")}
                format="YYYY-MM"
                onChange={onChange}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./src/template/MonthPicker.js